import Grid from '@material-ui/core/Grid'
import { get } from 'lodash'
import { Button, Show, TopToolbar, usePermissions, useRedirect } from 'react-admin'

import { hasPermission, Permissions } from '../../Permissions'
import Aside from '../Aside/aside'
import { CloneLoadButton, LoadShowLayout } from '../Common/Loads'

const LoadShowActions = ({ basePath, data }: any) => {
  const redirectTo = useRedirect()
  const { permissions } = usePermissions()
  if (!data || !permissions) {
    return null
  }
  const canCreateJob = hasPermission(permissions, Permissions.AddJob)
  const canCreateLoad = hasPermission(permissions, Permissions.AddLoad)
  const showAutoBidButton = get(data, 'has_auto_bid')

  return canCreateJob || canCreateLoad ? (
    <TopToolbar>
      <Grid container direction="row" spacing={2} justifyContent="flex-start">
        {canCreateJob && (
          <Grid item>
            <Button
              variant="contained"
              color="primary"
              onClick={() => redirectTo(`${basePath}/${data.id}/book`)}
              label="Book load"
            />
          </Grid>
        )}
        {showAutoBidButton && (
          <Grid item>
            <Button
              variant="contained"
              color="primary"
              onClick={() => redirectTo(`${basePath}/${data.id}/auto-bid`)}
              label="Auto-bid"
            />
          </Grid>
        )}
        {canCreateLoad && (
          <Grid item>
            <CloneLoadButton record={data} />
          </Grid>
        )}
        {canCreateLoad && (
          <Grid item>
            <Button
              variant="contained"
              color="primary"
              onClick={() =>
                redirectTo('/searches/create', '', undefined, {}, { initial_values: { load_id: data.id } })
              }
              label="Search for p/reload"
            />
          </Grid>
        )}
      </Grid>
    </TopToolbar>
  ) : null
}

const LoadShow = (props: any) => (
  <Show aside={<Aside />} actions={<LoadShowActions />} {...props}>
    <LoadShowLayout isContactedLoad={false} />
  </Show>
)

export default LoadShow
